module.exports = __webpack_public_path__ + "img/suez.57d6fca4.png";